export default {
  id: "uniqueProducts",
  name: "",
  description: "",
  report: {
    name: "Number of stock items",
    template: "custom",
    chartType: "NUMBER",
    config: {
      dataType: "single",
      dataSet: "Product",
      dimensions: [],
      measures: ["Product.distinct_count"],
      sort: {
        direction: "",
        by: "",
      },
      filters: [],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
